
// Protect users from spam
// 
// 
function gen_mail_to_link(lhs,rhs) {
    document.write("<a href=\"mailto");
    document.write(":" + lhs + "@");
    document.write(rhs + "\">" + lhs + "@" + rhs + "<\/a>");
}

(function($) {
    $(() => {

        $('.wpcf7-file').removeAttr('accept');

        $(window).scroll(function() {
            if($(window).scrollTop() > 56) {
                $('.navbar').addClass('is-scrolled');
            } else {
                $('.navbar').removeClass('is-scrolled');
            }
        });

        $('.language-selector').change(function(){
            window.location.href = $(this).val();
        });

    });
})(jQuery);
